var exports = {
  "n": "VoiceSceneChatPanel.module__panel___NkV1UX",
  "m": "VoiceSceneChatPanel.module__voiceSceneChatIn___NkV1UX",
};

module.exports = exports;
